import { Input, Select } from "antd";
import React, { createRef, useState, useEffect } from "react";
import AddButton from "../../../../Componets/Buttons/add";
import { select_search } from "../../../../Controllers/Global";
import toast from "react-hot-toast";
import { DeleteOutlined } from "@ant-design/icons";
import Error from "../../../../Componets/Error";
import { get_product_unit } from "../../../../Controllers/Products/Units";
import Required from "../../../../Componets/Required";

const Productunittable = React.forwardRef((props, focus) => {
  const { details, setDetails, upperForm } = props;
  const [basePrices, setBasePrices] = useState({
    purchase_price: 0,
    sale_price: 0,
    wholesale_price: 0
  });


  useEffect(() => {
    if (upperForm && Array.isArray(upperForm)) {
      const pricingSection = upperForm.find(section => section.name === "Pricing");
      if (pricingSection && pricingSection.options) {
        const newPrices = {
          purchase_price: 0,
          sale_price: 0,
          wholesale_price: 0
        };

        pricingSection.options.forEach(option => {
          switch (option.form?.name) {
            case 'purchase_price':
              newPrices.purchase_price = parseFloat(option.form?.value) || 0;
              break;
            case 'sale_price':
              newPrices.sale_price = parseFloat(option.form?.value) || 0;
              break;
            case 'wholesale_price':
              newPrices.wholesale_price = parseFloat(option.form?.value) || 0;
              break;
          }
        });

        setBasePrices(newPrices);

        recalculateUnitPrices(newPrices);
      }
    }
  }, [upperForm]);

  const calculateUnitPrice = (basePrice, conversion) => {
    if (!basePrice || !conversion || conversion <= 0) return 0;
    return (basePrice / conversion).toFixed(2);
  };

  const recalculateUnitPrices = (prices = basePrices) => {
    let data = [...details];

    data = data.map(item => {
      const conversion = parseFloat(item.conversion) || 0;

      if (conversion > 0) {
        return {
          ...item,
          purchase_price: calculateUnitPrice(prices.purchase_price, conversion),
          sale_price: calculateUnitPrice(prices.sale_price, conversion),
          wholesale_price: calculateUnitPrice(prices.wholesale_price, conversion)
        };
      }
      return item;
    });

    setDetails(data);
  };

  const handleSearch = async (e, index) => {
    let data = [...details];

    const select = {
      api: "get-all-product-units",
      search: e,
      status: 1,
    };

    const search = await select_search(select);

    if (search?.status) {
      let options = [];
      search?.data?.data?.map((value, index) => {
        options?.push({ value: value?._id, label: value?.name });
      });

      data[index].options = options;

      setDetails(data);
    } else {
      toast?.error(search?.message);
    }
  };

  const handleName = async (e, index) => {
    let data = [...details];

    if (e) {
      let ids = [];

      data?.map((v, i) => {
        ids?.push(v?.name);
      });

      if (!ids?.includes(e)) {
        let params = {
          id: e,
        };

        const product_unit = await get_product_unit(params);

        data[index].name = product_unit?.data?._id;
        data[index].label = product_unit?.data?.name;

        if (data[index].conversion) {
          const conversion = parseFloat(data[index].conversion);
          data[index].purchase_price = calculateUnitPrice(basePrices.purchase_price, conversion);
          data[index].sale_price = calculateUnitPrice(basePrices.sale_price, conversion);
          data[index].wholesale_price = calculateUnitPrice(basePrices.wholesale_price, conversion);
        }

        data[index].name = product_unit?.data?._id;
        data[index].label = product_unit?.data?.name;
        setDetails(data);
      } else {
        data[index].name = null;
        data[index].label = "";
        setDetails(data);
        toast?.error("Unit exists");
      }
    } else {
      data[index].name = null;
      data[index].label = "";
      data[index].conversion = "";
      data[index].purchase_price = "";
      data[index].sale_price = "";
      data[index].wholesale_price = "";
      setDetails(data);
    }
  };

  const handleConversion = (e, index) => {
    const value = parseFloat(e?.target?.value);

    if (value >= 0) {
      let data = [...details];

      data[index][e?.target?.name] = value;

      if (value > 0) {
        data[index].purchase_price = calculateUnitPrice(basePrices.purchase_price, value);
        data[index].sale_price = calculateUnitPrice(basePrices.sale_price, value);
        data[index].wholesale_price = calculateUnitPrice(basePrices.wholesale_price, value);
      } else {
        data[index].purchase_price = "";
        data[index].sale_price = "";
        data[index].wholesale_price = "";
      }

      setDetails(data);
    }
  };

  const handleRemove = (index) => {
    let data = [...details];

    data?.splice(index, 1);

    setDetails(data);
  };

  const handleAdd = () => {
    setDetails((prevDetails) => [
      ...prevDetails,
      {
        id: "",
        name: null,
        label: "",
        options: "",
        conversion: "",
        purchase_price: "",
        sale_price: "",
        wholesale_price: "",
      },
    ]);
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr>
            <td className="border p-4 text-black">
              Name
              <Required />
            </td>
            <td className="border p-4 text-black">
              Conversion
              <Required />
            </td>
            <td className="border p-4 text-black">
              Purchase&nbsp;price
              <span className="text-xs text-gray-500 block">
                Base: {basePrices.purchase_price.toFixed(3)}
              </span>
            </td>
            <td className="border p-4 text-black">
              Sale/Ret&nbsp;price
              <span className="text-xs text-gray-500 block">
                Base: {basePrices.sale_price.toFixed(3)}
              </span>
            </td>
            <td className="border p-4 text-black">
              Wholesale&nbsp;price
              <span className="text-xs text-gray-500 block">
                Base: {basePrices.wholesale_price.toFixed(3)}
              </span>
            </td>
            <td className="border p-4 text-black">Remove</td>
          </tr>
        </thead>
        <tbody>
          {details?.map((value, index) => {
            focus.current[`name${index}`] = createRef();
            focus.current[`conversion${index}`] = createRef();
            return (
              <React.Fragment>
                <tr>
                  <td className="border p-4 text-left">
                    {value?.name ? (
                      <div>
                        <div> {value?.label}</div>
                        <Error id={`name${index}`} />
                      </div>
                    ) : (
                      <div>
                        <Select
                          key={index}
                          name="name"
                          ref={focus.current[`name${index}`]}
                          className="w-[225px] text-regular"
                          placeholder="Name"
                          allowClear={true}
                          showSearch={true}
                          filterOption={false}
                          options={value?.options}
                          value={value?.name}
                          onSearch={(e) => handleSearch(e, index)}
                          onClick={(e) => handleSearch("", index)}
                          onChange={(e) => handleName(e, index)}
                          autoComplete="off"
                        />
                        <Error id={`name${index}`} />
                      </div>
                    )}
                  </td>
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="conversion"
                      ref={focus.current[`conversion${index}`]}
                      type="number"
                      className="w-full text-regular"
                      placeholder="Conversion"
                      value={value?.conversion}
                      onChange={(e) => handleConversion(e, index)}
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                    <Error id={`conversion${index}`} />
                  </td>
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="unit_purchase_price"
                      // ref={focus.current[`conversion${index}`]}
                      type="number"
                      className="w-full text-regular"
                      placeholder="Purchase Price"
                      value={value?.purchase_price}
                      // onChange={(e) => handleConversion(e, index)}
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                  </td>
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="unit_sale_price"
                      // ref={focus.current[`conversion${index}`]}
                      type="number"
                      className="w-full text-regular"
                      placeholder="Sale Price"
                      value={value?.sale_price}
                      // onChange={(e) => handleConversion(e, index)}
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                  </td>
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="unit_wholesale_price"
                      // ref={focus.current[`conversion${index}`]}
                      type="number"
                      className="w-full text-regular"
                      placeholder="Whole sale Price"
                      value={value?.wholesale_price}
                      // onChange={(e) => handleConversion(e, index)}
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                  </td>
                  <td className="border p-4 text-center">
                    <button
                      type="button"
                      className="text-lg text-red-500 cursor-pointer hover:text-red-800"
                      onClick={() => handleRemove(index)}
                    >
                      <DeleteOutlined />
                    </button>
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
      <div className="flex justify-end p-3">
        <AddButton onClick={handleAdd} />
      </div>
    </div>
  );
});

export default Productunittable;
